import React, { useEffect, useState } from "react";
import { Modal, Button, Placeholder, Whisper, Tooltip } from "rsuite";
import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { axiosPost, axiosUpdate } from "../../../common/utils/helper";
import { PostSkill, UpdateSkill } from "../../../common/utils/api";
import { EPInput } from "../../../common/controls";
import { CommonConstants } from "../../../common/utils/CommonConstants";
import Loader from "../../Loader/loader";
import { Info } from "../../../common/controls/info";

interface ReqBody {
  SkillName: String;
}
interface Props {
  open: boolean;
  action?: string;
  isValidate?: boolean;
  refresher?: boolean;
  setRefresher?: any;
  singleData?: any;
  setOpen: (open: boolean) => void;
}
export default function AddSkillModal(props: Props) {
  const { open, setOpen, action, setRefresher, singleData, refresher } = props;
  const [SkillName, setSkillName] = useState<string>(
    singleData?.SkillName ? singleData?.SkillName : ""
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [UpdateDisable, setUpdateDisable] = useState<boolean>(true);
  const [isValidate, setIsValidate] = useState(false);
  const regexPattern = /^(?!\d+$)(?!.*\s{2})(?!.*\.{2})(?!.*\.\s)[a-zA-Z0-9\s.]+$/

  let response: AxiosResponse;
  function closeModal() {
    setOpen(false);
  }
  function handleKeyPress(event: any) {
    if (
      (event.target.value.endsWith(" ") &&
      !regexPattern.test(event.target.value + event.key)) ||
      !regexPattern.test(event.target.value + event.key)
      ) {
      event.preventDefault();
    }
  }

  function handleModalKeyDown(event: React.KeyboardEvent<HTMLDivElement>) {
    if (event.key === "Enter" && !loading) {
      handleSubmit();
    }
  }

  async function handleSubmit() {
    if (SkillName?.trim().length < 1) {
      setIsValidate(true);
      toast.error("Please fill the mandatory field", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    } else {
      action === "Add"
        ? await postSkillName(PostSkill, SkillName.trim())
        : await updateSkillName(`${UpdateSkill}/${singleData.SkillId}`, {
          SkillName: SkillName.trim(),
        });
      refresher ? setRefresher(false) : setRefresher(true);
      closeModal();
    }
  }

  async function postSkillName(reqUrl: string, reqBody: string) {
    setLoading(true);
    response = (await axiosPost(reqUrl, { reqBody })) as AxiosResponse;
    if (
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "success"
    ) {
      setLoading(false);
      toast.success("Skill saved successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "error"
    ) {
      setLoading(false);
      toast.warning("Skill already exists", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }
  async function updateSkillName(reqUrl: string, reqBody: ReqBody) {
    response = (await axiosUpdate(reqUrl, reqBody)) as AxiosResponse;
    if (
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "success"
    ) {
      toast.success("Skill updated successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "error"
    ) {
      toast.warning("Skill already exists", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }

  function handleSkillChange(value: string) {
    setUpdateDisable(false);
    setSkillName(value);
  }
  return loading ? (
    <Loader />
  ) : (
    <>
      <Modal open={open} onClose={closeModal} className="modal-sm" backdrop="static" keyboard={false} onKeyDown={handleModalKeyDown} >
        <Modal.Header>
          <Modal.Title>{action} skill</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Skill<span className="text-danger">* </span>
          <Info message="Minimum 1 characters, Maximum 100 characters" />
          <Whisper trigger="focus" speaker={<Tooltip>Required</Tooltip>}>
            <EPInput
              onKeyPress={handleKeyPress}
              label="Skill"
              minlength={1}
              maxlength={100}
              style={{ width: 100 }}
              onChange={handleSkillChange}
              value={SkillName}
              isValidate={isValidate}
            />
          </Whisper>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={action === "Edit" && UpdateDisable}
            onClick={handleSubmit}
            className="float-start"
            appearance="primary"
          >
            {action === "Edit" ? "Update" : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
